import React, { useEffect, useRef, useState } from 'react';
import { Box, Paper, CardActions,Button, Typography, Chip, CircularProgress, Card, CardContent, Avatar } from '@mui/material';
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import { useSelector } from 'react-redux';

const CoinChart = () => {
    const appMode = useSelector((state) => state.mode.mode);
    const coinRates = useSelector((state) => state.coins.coinRates);
    const stocks = useSelector((state) => state.coins.stock);
    const currentPair = useSelector((state) => state.currentPair.currentPair);
    const pairType = useSelector((state) => state.currentPair.pairType);

    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

    const [coinDetails, setCoinDetails ] = useState(null);

    const calculate24hrChange = (coin) => {
      let pair = {};
      if (pairType === 'stocks') {
        stocks.forEach(stock => {
          if (stock.short_name === coin) {
            pair = stock;
          }
        });
      }else{
        coinRates.forEach(coinRater => {
          if (coinRater.symbol === coin) {
            pair = coinRater;
          }
        });
      }
     
    return pair;
    }

    useEffect(() => {
      setCoinDetails(calculate24hrChange(currentPair))    
      }, [AdvancedRealTimeChart]);
  return (
    <>
    {coinDetails !== null &&
    
    <Paper 
      sx={{ 
        bgcolor: '#1a1a1a',
        p: 0,
        borderRadius: 0,
        height: 'fit-content',
        position: 'relative'
      }}
    >
      
      <Card px={0} elevation={0}   sx={{borderRadius: '0px', marginX: 0, height: 'fit-content', marginBottom: '-90px', width: '100%'}}>
                
                        <CardContent  justifyContent="center" sx={{padding: 0, marginTop: '5px', marginX: 0, marginBottom: '0px'}}>
                        <AdvancedRealTimeChart
                                symbol= { pairType === 'stocks' ? `${coinDetails.exch}:${coinDetails.short_name}` : `BINANCE:${currentPair}USDT`}
                                interval= "D"
                                timezone= "Etc/UTC"
                                theme= {appMode}
                                locale= "en"
                                style='1'
                                hide_top_toolbar= {false}
                                enable_publishing= {false}
                                save_image={false}
                                backgroundColor={appMode === 'dark' ? '#1e1e1e' : '#ffffff'}
                                hide_side_toolbar={true}
                                allow_symbol_change={false}
                                container_id= "898980"
                                isTransparent = {true} 
                                popup_height='650'
                                popup_width='1000'
                                range='YTD'
                                
                                height={450}
                                width="100%"
                              >
                               </AdvancedRealTimeChart>
                          {appMode === 'dark'? 
                          <Box sx={{height: '20px', backgroundColor: '#1e1e1e', transform: 'translate(0px, -25px)', position: 'relative'}}>
                          
                          </Box>
                          :
                          <Box sx={{height: '20px', backgroundColor: 'white', transform: 'translate(0px, -25px)', position: 'relative'}}>
                          
                          </Box>
                          }
                          <Avatar sx={{display: 'absolute', zIndex: 10, transform: 'translate(10px, -170px)'}} alt="Payment icon" src="https://res.cloudinary.com/dnjauzgbv/image/upload/v1741162934/trustedgeappicon_j9am1e.png" />
                          
                          </CardContent>
                          

                    </Card>
            
                    
    </Paper>
      }
    </>
  );
};

export default CoinChart;
